import { Text, View } from "react-native";

const BROWN = "#6B5548";
const BROWN_BG = "rgba(139, 111, 94, 0.1)";

export function NeutralStepPill({ label }: { label: string }) {
  return (
    <View
      style={{
        alignSelf: "flex-start",
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 5,
        backgroundColor: BROWN_BG,
      }}
    >
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 10,
          fontWeight: "600",
          color: BROWN,
          textTransform: "uppercase",
          letterSpacing: 0.5,
        }}
      >
        {label}
      </Text>
    </View>
  );
}
